import ReturnsTableConst from "../ReturnsTable/const";

const Const = {
    DASHBOARDS_METRICS_START_FETCH_REQUEST: 'DASHBOARDS_METRICS_START_FETCH_REQUEST',
    DASHBOARDS_METRICS_FETCH_REQUEST: 'DASHBOARDS_METRICS_FETCH_REQUEST',
    [ReturnsTableConst.RETURNS_TABLE_CHANGE_FILTERS_BY_INBOUND_METRICS]: ReturnsTableConst.RETURNS_TABLE_CHANGE_FILTERS_BY_INBOUND_METRICS
};

export default Const;